define(['angular'], function(angular) {


    /**
     * @class PromotionService
     */
    function PromotionService(tillPackService, commonService) {
        var self = this;
        var promotions = [];

        self.init = function init(orderForm, order) {
            promotions = orderForm.promotions;

            for (var i = 0; i < promotions.length; i++) {
                for (var j = 0; j < order.promotions.length; j++) {
                    if (order.promotions[j].id === promotions[i].id) {
                        promotions[i].selected = true;
                        break;
                    }
                }
            }

            promotions = promotions.reduce((curr, promo)=> {
                if(commonService.isInDateRange(order.dateCreated, promo.promotionStartDateValidity, promo.promotionEndDateValidity))
                    curr.push(promo);
                return curr;
            },[]);
        };

        self.getPromotions = function getPromotions() {
            return promotions;
        };

        self.getPromotionCodeFromTillCode = function (tillCode) {
            if (tillCode === 'PREMIUM' || tillCode === 'ESSENTIEL' || tillCode === 'BT+') {
                return 'B_TOUCH';
            }
            else if (tillCode === 'BM' || tillCode === 'BM+') {
                return 'B_MOOV';
            }
            else if (tillCode === 'BS_PREMIUM') {
                return 'B_SMART';
            }else if (tillCode === 'BSW_PREMIUM' || tillCode === 'BSW_ESSENTIEL') {
                return 'B_SWIFT';
            }else if (tillCode === 'BC_ESSENTIEL'){
                return 'B_COMPACT';
            }
            return null;
        };

        self.promotionCanBeActivated = function (promotion, tills, veto, isExceptionalOffer, options, cashdrawers, priceOk) {
            if (veto) {
                return false;
            }
            if (promotion.code === 'B_MOOV' && (tillPackService.hasBmoovPack(tills) || tillPackService.hasBmoovPlusPack(tills))) {
                return !isExceptionalOffer;
            }
            if (promotion.code === 'B_TOUCH' && tillPackService.hasBtouchPack(tills)) {
                return !isExceptionalOffer && cashdrawers.find(c => !c.refurbished) && options.find(o => o.code === 'SCANNER-GRYPHON' && !o.refurbished) && priceOk;
            }
            if (promotion.code === 'B_SMART' && tillPackService.hasPremiumBsmartPack(tills)) {
                if(promotion.description === 'Promotion B Smart + Pôle'){
                    const pole = options.find(opt => opt.code === 'POLE-DOUBLE-BS');
                    return !(pole===undefined);
                }
                let onlyBsmart = tillPackService.isOnlyBSmartPremiumPack(tills)
                let tillsPack = tills.find(t => t.tillType.code === 'BS_PREMIUM');
                return onlyBsmart && tillsPack && tillsPack.nbTills === 1;
            }
            if((promotion.code === 'B_SWIFT' && tillPackService.hasBswiftPack(tills)) || (promotion.code === 'B_COMPACT' && tillPackService.hasBCompactPack(tills))){
                return !isExceptionalOffer && cashdrawers.find(c => !c.refurbished) && options.find(o => o.code === 'SCANNER-GRYPHON' && !o.refurbished)
            }

            return false;
        };

        self.promotionIsAvailable = function (promotion, isNap) {
            if (promotion.code === 'B_TOUCH') {
                return true;
            }
            if ((promotion.code === 'B_MOOV' || promotion.code === 'B_SMART' || promotion.code === 'B_SWIFT' || promotion.code === 'B_COMPACT')  && !isNap) {
                return true;
            }
            return false;
        };

        self.groupValuesByPromotionCode = function (promotionValuesBytillsCode) {
            var promotionValues = {
                B_TOUCH: 0,
                B_MOOV: 0,
                B_SMART: 0,
                B_SWIFT: 0,
                B_COMPACT: 0,
            };
            for (const tillCode in promotionValuesBytillsCode) {
                if (tillCode === 'PREMIUM' || tillCode === 'ESSENTIEL' || tillCode === 'BT+') {
                    promotionValues['B_TOUCH'] += promotionValuesBytillsCode[tillCode];
                }
                else if (tillCode === 'BM' || tillCode === 'BM+') {
                    promotionValues['B_MOOV'] += promotionValuesBytillsCode[tillCode];
                }
                else if (tillCode === 'BS_PREMIUM'){
                    promotionValues['B_SMART'] += promotionValuesBytillsCode[tillCode];
                }
                else if (tillCode === 'BSW_PREMIUM' || tillCode === 'BSW_ESSENTIEL') {
                    promotionValues['B_SWIFT'] += promotionValuesBytillsCode[tillCode];
                }else if (tillCode === 'BC_ESSENTIEL'){
                    promotionValues['B_COMPACT'] += promotionValuesBytillsCode[tillCode];
                }
            }
            return promotionValues;
        };

        self.mapOrderFormData = function (orderPromotions, orderFormPromotions) {
            for (var i = 0; i < orderPromotions.length; i++) {
                for (var j = 0; j < orderFormPromotions.length; j++) {
                    if (orderPromotions[i].id === orderFormPromotions[j].id) {
                        orderPromotions[i] = orderFormPromotions[j];
                        break;
                    }
                }
            }
            return orderPromotions;
        };

        self.hasOnePromotion = function (promotions) {
            return !!promotions.length;
        };

        self.hasBmoovPromotion = function (promotions) {
            for (const promotion of promotions) {
                if (promotion.code === 'B_MOOV') {
                    return true;
                }
            }
            return false;
        };

        self.hasBTouchPromotion = function (promotions) {
            for (const promotion of promotions) {
                if (promotion.code === 'B_TOUCH') {
                    return true;
                }
            }
            return false;
        };

        self.hasBSwiftPromotion = function (promotions) {
            for (const promotion of promotions) {
                if (promotion.code === 'B_SWIFT') {
                    return true;
                }
            }
            return false;
        };

        self.hasBCompactPromotion = function (promotions) {
            for (const promotion of promotions) {
                if (promotion.code === 'B_COMPACT') {
                    return true;
                }
            }
            return false;
        };

        return self;
    }

    PromotionService.$inject = ['tillPackService', 'commonService'];

    angular.module('app.bdc.common.promotionService', []).factory('promotionService', PromotionService);
});
